import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: [],
    reducers: {
        add(state, action){
            let s = state.filter(item => item._id !== action.payload._id);
            s.push(action.payload);
            return s;
        },
        remove(state,action){
            return state.filter(item => item._id !== action.payload);
        },
        reset(state,action){
            return [];
        }
    }   
});

export const {add,remove,reset} = cartSlice.actions;

export default cartSlice.reducer;